/**
 * Calculates the total of values in an array, optionally accessing nested fields
 * @param array - Array of objects or numbers to sum
 * @param field - Optional dot notation string to access nested fields (e.g. 'user.stats.count')
 * @returns The total sum
 */
const getTotal = <T>(array: T[] = [], field: string | null = null): number => {
  const getNestedValue = (obj: any, path: string): any => {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj)
  }

  if (array && array.length > 0) {
    if (field) {
      return array
        .map(item => +getNestedValue(item, field) || 0)
        .reduce((a, b) => a + b, 0)
    } else {
      return (array as unknown as number[]).reduce((a, b) => a + b, 0)
    }
  } else {
    return 0
  }
}

export default getTotal
